export default __webpack_public_path__ + "f78ffc04acb877ce387e91e68cb3d28e.ttf";